export default __webpack_public_path__ + "static/media/condominios.a8400d72.jpg";